
<template>
    <el-card class="page_card" v-loading="!is_ok">
        <div slot="header" class="flex">
            <el-page-header @back="goBack" content="添加计划单" style="align-items: center;"></el-page-header>
            <div class="view_section_right_view" @click="onButtonClick">
                智能识别
            </div>
        </div>
        <!-- <el-steps :active="activeNum" align-center>
            <el-step title="填写订单基本信息" icon="el-icon-edit"></el-step>
            <el-step title="填写订单金额信息" icon="el-icon-bank-card"></el-step>
            <el-step title="确认订单" icon="el-icon-document-checked"></el-step>
            <el-step title="提交完成" icon="el-icon-position"></el-step>
        </el-steps> -->
        <el-row>
            <el-form :model="form" ref="basicForm" label-width="120px" style="margin: 0 auto" :rules="basicRules">
                <el-col :lg="14" :offset="4" style="padding: 20px;margin-top: 30px;">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="企业名称" prop="comId">
                                <el-select
                                    style="width: 100%"
                                    v-model="form.comId"
                                    :multiple="false"
                                    filterable
                                    remote
                                    reserve-keyword
                                    placeholder="请输入企业名称/简称"
                                    @change="comChange"
                                    :loading="is_select">
                                    <el-option
                                        v-for="item in componys"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="产品" prop="goodsId">
                                <el-select v-model="form.goodsId" placeholder="请选择订购的产品" @change="goodsChange" :disabled="form.comId === ''" style="width:100%">
                                    <el-option
                                        :class="{primary_text:item.isMain == 1}"
                                        v-for="item in goods_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="计划日期" prop="date">
                                <el-select v-model="form.date" placeholder="请选择装液日期" style="width:100%">
                                    <el-option
                                        v-for="item in dates"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>                       
                            <el-form-item label="主车号" prop="plateNumber">
                                <el-select v-model="form.plateNumber" :filter-method="plateNumberInput"  default-first-option filterable remote
                                    @change="WOStatusChange"
                                    id="plateNumberInput"
                                    style="width:100%"
                                    placeholder="请输入装液主车号: 宁A12L45" >
                                    <el-option v-for="(item,index) in plateNumberList" :key="index" :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="挂车号" prop="carriageNumber">
                                <el-select v-model="form.carriageNumber" :filter-method="carriageNumberInput" default-first-option filterable remote
                                    style="width:100%"
                                    id="carriageNumberInput"
                                    placeholder="请输入装液挂车号: 宁A1234挂">
                                    <el-option v-for="(item,index) in carriageNumberList" :key="index" :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="驾驶员" prop="driverName">
                                <el-select v-model="form.driverName" allow-create default-first-option filterable
                                    style="width:100%"
                                    placeholder="请输入驾驶员" >
                                    <el-option v-for="(item,index) in driverNameList" :key="index" :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="驾驶员电话" prop="driverMobile">
                                <el-select v-model="form.driverMobile" allow-create default-first-option filterable 
                                    style="width:100%"
                                    placeholder="请输入驾驶员电话" >
                                    <el-option v-for="(item,index) in driverMobileList" :key="index" :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>   
                            <el-form-item label="押运员" prop="escortName">
                                <el-input v-model="form.escortName" placeholder="请输入押运员名称"  maxlength="10" show-word-limit></el-input>
                            </el-form-item>
                            <el-form-item label="押运员电话" prop="escortMobile">
                                <el-input v-model="form.escortMobile" placeholder="请输入押运员电话" maxlength="11" show-word-limit></el-input>
                            </el-form-item>
                             <el-form-item label="计划单备注" prop="remark">
                                <el-input v-model="form.remark" type="textarea" maxlength="100" :autosize="{ minRows: 4, maxRows: 8}" placeholder="计划单备注" show-word-limit></el-input>
                            </el-form-item>
                             
                            <!-- <el-form-item label="计划单类型">
                                <el-radio-group v-model="form.type" @change="typeChange">
                                    <el-radio-button label="0">本厂计划</el-radio-button>
                                    <el-radio-button label="1">其他计划</el-radio-button>
                                </el-radio-group>
                            </el-form-item> -->
                        </el-col>
                        <el-col :span="12"> 
                            <el-form-item label="供应商" v-if="form.type == '1'" prop="supplierId">
                                <el-select style="width: 100%" v-model="form.supplierId"  placeholder="请选择">
                                    <el-option
                                        v-for="item in supplier_list"
                                        :key="item.id"
                                        :label="item.displayName"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="提货方式">
                                <el-radio-group v-model="form.transport">
                                    <el-radio-button label="0">自提</el-radio-button>
                                    <el-radio-button label="1">配送</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="卸液地点" v-if="form.transport == '1'">
                                <div>
                                    <el-tag
                                        class="text-overfolow"
                                        :key="tag"
                                        v-for="tag in form.destinations"
                                        style="max-width: 100%;position: relative"
                                        :disable-transitions="false">
                                        {{tag}}
                                        <i class="el-icon-circle-close" @click="handleClose(tag)" />
                                    </el-tag>
                                </div>
                                <div>
                                    <el-button type="success" plain size="mini" @click="addAddress">+ 添加卸液地</el-button>
                                </div>
                            </el-form-item>
                            <el-form-item label="物流公司">
<!--                                <el-input v-model="form.expressName" placeholder="请输入物流公司名称"></el-input>-->
                                <el-autocomplete
                                    style="width: 100%"
                                    class="inline-input"
                                    v-model="form.expressName"
                                    :fetch-suggestions="querySearchExpressName"
                                    placeholder="请输入物流公司名称"
                                    :trigger-on-focus="false"
                                    :maxlength="20"
                                    show-word-limit
                                ></el-autocomplete>
                            </el-form-item>
                            <el-form-item label="计划装货量(吨)" prop="planWeight">
                                <el-input v-model="form.planWeight" placeholder="计划装货量"></el-input>
                            </el-form-item>
                            <el-form-item label="当前挂牌价" v-if="activeGoods">
                                <span style="font-size: 14px;" class="primary_text"> {{activeGoods.price}} 元/吨</span>
                            </el-form-item>
                            <!-- <el-form-item label="实际价格(元/吨)" prop="realPrice">
                                <el-input v-model="form.realPrice" placeholder="请输入该产品的实际价格"></el-input>
                            </el-form-item> -->
                            <el-form-item label="长期优惠(元/吨)">
                                <span class="warning_text"> {{form.temCut}} 元/吨</span>
                            </el-form-item>
                            <el-form-item label="销售员优惠(元/吨)" prop="saleCut">
                                <el-input v-model="form.saleCut" placeholder="请输入销售员优惠(元/吨)"></el-input>
                            </el-form-item>
                            <!--  v-if="isShowLng"--针对lng产品 -->
                            <el-form-item label="车辆优惠(元/吨)">
                                <span class="warning_text">  {{currDiscountData}}元/吨</span>
                            </el-form-item>
                            <el-form-item label="其他费用">
                                <el-table border :data="form.otherFee" size="mini" empty-text="无其他费用">
                                    <el-table-column label="费用名目">
                                        <template slot-scope="scope">
                                            {{scope.row.name}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="费用">
                                        <template slot-scope="scope">
                                            <span class="warning_text">￥ {{scope.row.num}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作">
                                        <template slot-scope="scope">
                                            <el-link :underline="false" type="danger" size="mini" @click="delOther(scope)"><i class="el-icon-delete"></i></el-link>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-button size="mini" type="success" v-can="['btn:other_expenses']" plain @click="addOtherDialog = !addOtherDialog">+ 添加其他费用</el-button>
                            </el-form-item>
                            <el-form-item label="上期余额(元)" v-if="activeCom">
                                <span class="primary_text" style="font-size: 14px"> {{activeCom.balance.toFixed(2)}} 元</span>
                            </el-form-item>
                            <el-form-item label="本期余额(元)" v-if="activeCom">
                                <span :class="parseNextBalance() < 0 ?'danger_text':'primary_text'" style="font-size: 14px"> {{parseNextBalance()}} 元</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    
                </el-col>
                <el-col :lg="14" :offset="4" style="padding:0px 20px; ">
                    <el-row>
                        <el-col :span="12">
                              <el-form-item label="成交价">
                                <span class="primary_text"> {{isNaN(parseEndPrice())?'':parseEndPrice()}} 元/吨</span>
                            </el-form-item>
                           
                        </el-col>
                        <el-col :span="12">
                             <el-form-item label="计划总金额">
                                <span class="primary_text"> {{isNaN(parseTotal())?'':parseTotal()}} 元</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-alert title="成交价 = 当前挂牌价 - 长期优惠 - 销售员优惠 - 车辆优惠 + 其他费用" type="warning" show-icon style="margin-bottom: 20px"></el-alert>
                    <el-alert title="计划总金额 = 计划装货量 * (当前挂牌价 - 长期优惠 - 车辆优惠 - 销售员优惠 + 其他费用) " show-icon type="warning" style="margin-bottom: 20px"></el-alert>
                    <el-row class="flexBox">
                        <el-button plain style="float:right" type="primary" @click="submitOrder" :loading="false">提交</el-button>
                    </el-row>
                </el-col>
            </el-form>
        </el-row>
        <!-- <el-row v-show="activeNum == 1">
            <el-form :model="form" ref="priceForm" label-width="130px" style="margin: 0 auto" :rules="priceRules">
                <el-col :lg="14" :offset="4" style="padding: 20px;margin-top: 30px;">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="计划装货量(吨)" prop="planWeight">
                                <el-input v-model="form.planWeight" placeholder="计划装货量"></el-input>
                            </el-form-item>
                            <el-form-item label="当前挂牌价(元/吨)" v-if="activeGoods">
                                <span style="font-size: 14px;" class="primary_text"> {{activeGoods.price}} 元/吨</span>
                            </el-form-item>
                            <el-form-item label="实际价格(元/吨)" prop="realPrice">
                                <el-input v-model="form.realPrice" placeholder="请输入该产品的实际价格"></el-input>
                            </el-form-item>
                            <el-form-item label="临时优惠(元/吨)">
                                <span class="warning_text"> {{form.temCut}} 元/吨</span>
                            </el-form-item>
                            <el-form-item label="销售优惠(元/吨)" prop="saleCut">
                                <el-input v-model="form.saleCut" placeholder="请输入销售优惠(元/吨)"></el-input>
                            </el-form-item>
                            <el-form-item label="最终价格">
                                <span class="primary_text"> {{isNaN(parseEndPrice())?'':parseEndPrice()}} 元/吨</span>
                            </el-form-item>
                            <el-form-item label="计划总金额">
                                <span class="primary_text"> {{isNaN(parseTotal())?'':parseTotal()}} 元</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="其他费用">
                                <el-table border :data="form.otherFee" size="mini" empty-text="无其他费用">
                                    <el-table-column label="费用名目">
                                        <template slot-scope="scope">
                                            {{scope.row.name}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="费用">
                                        <template slot-scope="scope">
                                            <span class="warning_text">￥ {{scope.row.num}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作">
                                        <template slot-scope="scope">
                                            <el-link :underline="false" type="danger" size="mini" @click="delOther(scope)"><i class="el-icon-delete"></i></el-link>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-button size="mini" type="success" plain @click="addOtherDialog = !addOtherDialog">+ 添加其他费用</el-button>
                            </el-form-item>
                            <el-form-item label="上期余额(元)" v-if="activeCom">
                                <span class="primary_text" style="font-size: 14px"> {{activeCom.balance}} 元</span>
                            </el-form-item>
                            <el-form-item label="本期余额(元)" v-if="activeCom">
                                <span :class="parseNextBalance() < 0 ?'danger_text':'primary_text'" style="font-size: 14px"> {{parseNextBalance()}} 元</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-alert title="最终价格 = 实际价格 - 临时优惠 - 销售优惠" type="warning" show-icon style="margin-bottom: 20px"></el-alert>
                    <el-alert title="计划总金额 = 计划装货量 * (实际价格 - 临时优惠 - 销售优惠) + 其他费用" show-icon type="warning" style="margin-bottom: 20px"></el-alert>
                    <el-row>
                        <el-button plain style="float:left" @click="prov(1)">上一步</el-button>
                        <el-button plain style="float:right" type="primary" @click="next(1)">下一步</el-button>
                    </el-row>
                </el-col>
            </el-form>
        </el-row> -->
        <!-- <el-row v-show="activeNum == 2">
            <el-col :lg="14" :offset="4" style="padding: 0px 20px;margin-top: 30px;">
                计划单基本信息
                <el-divider></el-divider>
                <el-row style="border-bottom: 1px solid #dedede;margin-bottom: 20px">
                    <el-form v-model="form" label-width="130px">
                        <el-col :span="12">
                            <el-form-item label="企业名称:" v-if="activeCom">
                                <span class="primary_text">{{activeCom.name}}</span>
                            </el-form-item>
                            <el-form-item label="采购产品:" v-if="activeGoods">
                                <span class="success_text">{{activeGoods.name}}</span>
                            </el-form-item>
                            <el-form-item label="计划日期:">
                                {{form.date}}
                            </el-form-item>
                            <el-form-item label="计划单类型:">
                                <span class="primary_text" v-if="form.type == 0">本厂计划</span>
                                <span class="warning_text" v-else-if="form.type == 1">其他计划</span>
                            </el-form-item>
                            <el-form-item label="提货方式:">
                                <span class="primary_text" v-if="form.transport == 0">自提</span>
                                <span class="warning_text" v-if="form.transport == 1">配送</span>
                            </el-form-item>
                            <el-form-item label="供应商:" v-if="form.type == 1 && form.supplierId">
                                <span class="primary_text">{{parseSupplierId(form.supplierId)}}</span>
                            </el-form-item>
                            <el-form-item label="卸液地:">
                                <div v-if="form.destinations.length == 0">
                                    暂无卸液地
                                </div>
                                <div v-else>
                                    <div style="width: 100%" v-for="address of form.destinations">
                                        <el-tag type="primary">{{address}}</el-tag>
                                    </div>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="物流公司:">
                                <span class="primary_text">{{form.expressName}}</span>
                            </el-form-item>
                            <el-form-item label="主车号:">
                                <span>{{form.plateNumber}}</span>
                            </el-form-item>
                            <el-form-item label="挂车号:">
                                <span>{{form.carriageNumber}}</span>
                            </el-form-item>
                            <el-form-item label="司机姓名:">
                                <span>{{form.driverName}}</span>
                            </el-form-item>
                            <el-form-item label="司机手机号:">
                                <span>{{form.driverMobile}}</span>
                            </el-form-item>
                            <el-form-item label="押运员姓名:">
                                <span>{{form.escortName}}</span>
                            </el-form-item>
                            <el-form-item label="押运员手机号:">
                                <span>{{form.escortMobile}}</span>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </el-row>
                计划单金额信息
                <el-divider></el-divider>
                <el-form label-width="130px" v-model="form" style="border-bottom: 1px solid #dedede;margin-bottom: 20px">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="计划装货量:">
                                <span class="primary_text">{{form.planWeight}} 吨</span>
                            </el-form-item>
                            <el-form-item label="当前挂牌价:" v-if="activeGoods">
                                <span style="font-size: 14px" class="warning_text"> {{activeGoods.price}} 元/吨</span>
                            </el-form-item>
                            <el-form-item label="实际价格:">
                                <span class="primary_text"> {{form.realPrice}} 元/吨</span>
                            </el-form-item>
                            <el-form-item label="临时优惠:">
                                <span class="warning_text"> {{form.temCut}} 元/吨</span>
                            </el-form-item>
                            <el-form-item label="销售优惠:">
                                <span class="warning_text"> {{form.saleCut}} 元/吨</span>
                            </el-form-item>
                            <el-form-item label="最终价格:">
                                <span class="primary_text"> {{isNaN(parseEndPrice())?'':parseEndPrice()}} 元/吨</span>
                            </el-form-item>
                            <el-form-item label="计划总金额:">
                                <span class="primary_text"> {{isNaN(parseTotal())?'':parseTotal()}} 元</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="其他费用:">
                                <el-table border :data="form.otherFee" size="mini" empty-text="无其他费用">
                                    <el-table-column label="费用名目">
                                        <template slot-scope="scope">
                                            {{scope.row.name}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="费用">
                                        <template slot-scope="scope">
                                            <span class="warning_text">￥ {{scope.row.num}}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-form-item>
                            <el-form-item label="上期余额:" v-if="activeCom">
                                <span class="primary_text">
                                    ￥ {{activeCom.balance}}
                                </span>
                            </el-form-item>
                            <el-form-item label="本期余额:" v-if="activeCom">
                                <span :class="parseNextBalance()>0?'primary_text':'danger_text'" :underline="false">
                                    ￥ {{parseNextBalance()}}
                                </span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                计划单备注
                <el-divider></el-divider>
                <el-row style="margin-bottom: 20px">
                    <el-col :span="24">
                        <el-input v-model="form.remark" type="textarea" maxlength="100" :autosize="{ minRows: 4, maxRows: 8}" placeholder="计划单备注" show-word-limit></el-input>
                    </el-col>
                </el-row>
                <el-row>
                    <el-button plain style="float:left" @click="prov(2)">上一步</el-button>
                    <el-button plain style="float:right" type="primary" @click="submitOrder" :loading="false">确认提交</el-button>
                </el-row>
            </el-col>
        </el-row> -->
        <!-- <el-row v-show="activeNum == 3">
            <el-col :lg="14" :offset="4" style="padding: 20px;margin-top: 30px;">
                <div style="font-size: 120px;text-align: center;color: #67C23A;margin-bottom: 10px">
                    <svg-icon icon-class="success" />
                </div>
                <div style="font-size: 25px;text-align: center;color: #444444;margin-bottom: 20px">
                    添加计划操作成功
                </div>
                <div style="font-size: 16px;text-align: center;color: #666666;margin-bottom: 20px">
                    是否继续添加?
                </div>
                <div style="text-align: center">
                    <el-button plain @click="toList">跳转至列表页</el-button>
                    <el-button plain type="primary" @click="addAgain" :loading="is_post">确 定</el-button>
                </div>
            </el-col>
        </el-row> -->

        <el-dialog title="添加其他费用" :visible.sync="addOtherDialog" width="25%">
            <el-form ref="addForm" label-width="150px" :model="addForm" :rules="addRules">
                <el-form-item label="其他费用名称" prop="name">
                    <el-input v-model="addForm.name" placeholder="请输入其他费用名录" maxlength="10" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="其他费用金额(元/吨)" prop="num">
                    <el-input v-model="addForm.num" placeholder="请输入其他费用金额(元/吨)" maxlength="10" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="" class="flexBox" style="margin-right:150px;">
                    <el-button type="primary" plain @click="addOther">提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="智能识别" :visible.sync="is_smart" width="35%" @close='handleCancle'>
            <div class="box">
                <div class="box-title">
                    <span>智能输入短信信息</span>
                </div>
                <div>
                    <el-input v-model="inputVal" @input="smartInput" @change="btnInput" class="textarea-box" :autosize="{ minRows: 6, maxRows: 12}" placeholder-class="remark-box" type="textarea" maxlength="50000"  placeholder="请输入需要识别的内容，每条信息之间用#号隔开，例：车牌号：XXXXXX 车挂号：XXXXXX挂 司机:XXX 手机号：1XXXXXXXXXXX 押运员:XXX 手机号:1XXXXXXXXXXX"></el-input>
                </div>
                <div class="btn-box">
                    <div @click="resetBtn" class="btn-common btn-reset">清空</div>
                    <div @click="btnClick" class="btn-common btn-identify">识别</div>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="智能识别列表" :visible.sync="is_smart_list" width="35%" @close='handleCancleList'>
            <div v-for="item in orderList" :key="item.id"  class="order-list">
                <div @click="btnClickList(item.orderData)" class="order-text">{{item.name}}</div>
            </div>
        </el-dialog>

    </el-card>
</template>

<script>
import request from '@/utils/request'
import {parseTime,deepClone} from '@/utils'
import math from '@/utils/math'
import can from "@/directive/can/index.js"
import {stringTrim} from '@/utils/elvalid'
import { index } from 'mathjs'

export default {
    name: 'plan_add',
    directives:{can},
    data(){
        let two_polt = {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2}|0)$/,message:"请输入一个正数,最多保留2位小数",trigger: 'blur'};
        return {
            is_ok:false,
            is_select:false,
            is_post:false,
            is_smart:false,
            inputVal:'',
            newInputList:[],
            is_smart_list:false,
            orderList:[],
            orderListDetail:[],
            plateNumber:"",
            form:{
                comId:"",//公司id
                // comName:'',
                type:0,// 0 本厂计划  1其他计划
                supplierId:"",//供应商id
                transport:0, // 0 自提  1配送
                date:"", //时间
                plateNumber:"",
                carriageNumber:"",
                driverName:"",
                driverMobile:"",
                escortName:"",
                escortMobile:"",
                destinations:[],
                expressName:"",//物流公司
                goodsId:'',
                planWeight:"22.5",
                realPrice:"",
                temCut:"",
                saleCut:"",
                remark:"",
                otherFee:[],
                total:0
            },
            priceRules:{
                realPrice:[
                    {required: true, message: '请输入实际价格', trigger: 'blur'},
                    {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,message:"请输入一个正数,最多保留2位小数",trigger: 'blur'}
                ],
                planWeight:[
                    {required: true, message: '请输入计划装货量', trigger: 'blur'},
                    {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,message:"请输入一个正数,最多保留2位小数",trigger: 'blur'}
                ],
                saleCut:[
                    // {required: true, message: '请输入销售优惠', trigger: 'blur'},
                    two_polt
                ]
            },
            basicRules:{
                comId:[
                    { required: true, message: '请选择一个企业', trigger: 'change' }
                ],
                supplierId:[
                    {required: true, message: '请选择一个供应商', trigger: 'change'}
                ],
                date:[
                    {required: true, message: '请选择计划单时间', trigger: 'change'}
                ],
                plateNumber:[
                    {required: true, message: '请输入主车号', trigger: 'blur'},
                    {pattern:/^[京津晋冀蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁新][ABCDEFGHJKLMNPQRSTUVWXY][\dABCDEFGHJKLNMxPQRSTUVWXYZ]{5}$/,message:"请输入正确的主车号",trigger: 'blur'}
                ],
                carriageNumber:[
                    {required: true, message: '请输入挂车号', trigger: 'blur'},
                    {pattern:/^[京津晋冀蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁新][ABCDEFGHJKLMNPQRSTUVWXY][\dA-Z]{4}挂$/,message:"请输入正确的挂车号",trigger: 'blur'}
                ],
                driverName:[
                    {required: true, message: '请输入驾驶员', trigger: 'blur'},
                    { validator: stringTrim, trigger: 'blur' }
                ],
                // escortName:[
                //     { validator: stringTrim, trigger: 'blur' }
                // ],
                driverMobile:[
                    {required: true, message: '请输入电话', trigger: 'blur'},
                    {pattern:/^1[345789]\d{9}$/,message:"请输入正确的电话",trigger: 'blur'}
                ],
                escortMobile:[
                    {pattern:/^1[345789]\d{9}$/,message:"请输入正确的电话",trigger: 'blur'}
                ],
                expressName:[
                    {required: true, message: '请输入物流公司名称', trigger: 'blur'},
                    { validator: stringTrim, trigger: 'blur' }
                ],
                goodsId:[
                    {required: true, message: '请选择一个产品', trigger: 'change'}
                ],
                realPrice:[
                    {required: true, message: '请输入实际价格', trigger: 'blur'},
                    {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,message:"请输入一个正数,最多保留2位小数",trigger: 'blur'}
                ],
                planWeight:[
                    {required: true, message: '请输入计划装货量', trigger: 'blur'},
                    {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,message:"请输入一个正数,最多保留2位小数",trigger: 'blur'}
                ],
                saleCut:[
                    // {required: true, message: '请输入销售优惠', trigger: 'blur'},
                    two_polt
                ]
            },
            companyName:"",
            vehicleLists:[],
            plateNumberList:[],
            plateNumberListCopy:[],
            driverNameList:[],
            carriageNumberList:[],
            carriageNumberListCopy:[],
            driverMobileList:[],
            realPrice:"",
            dates:[],
            componys:[],
            goods_list:[],
            activeNum:0,
            supplier_list:[],
            addOtherDialog:false,
            addForm:{
                name:"",
                num:""
            },
            addRules:{
                name:[
                    { required: true, message: '请输入其他费用名录', trigger: 'blur' },
                    { validator: stringTrim, trigger: 'blur' }
                ],
                num:[
                    { required: true, message: '请输入其他费用金额', trigger: 'blur' },
                    {pattern:/^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,message:"请输入一个数字,最多保留2位小数",trigger: 'blur'}
                ]
            },
            activeGoods:null,
            activeCom:null,
            editData:{},
            currDiscountData:0,
            isShowLng:false,
        }
    },
    computed:{

    },
    methods:{
        goBack(){
            this.$router.go(-1);
        },
        onButtonClick() {
            this.is_smart=true;
        },
        handleCancle () {
            this.is_smart = false;
            this.inputVal='';
        },
        handleCancleList () {
            this.is_smart_list = false;
            this.orderList=[];
        },
        btnInput(e) {
            // this.inputVal=e;
        },
        smartInput(e){
            this.inputVal = e.toUpperCase()
        },
        resetBtn() {
            this.inputVal='';
        },
        plateNumberInput(e){
            let input = document.getElementById("plateNumberInput");
            input.value = e.toUpperCase();
            if(e){
                if (this.plateNumberList.length == this.plateNumberListCopy.length) {
                    this.plateNumberList.unshift(e.toUpperCase());
                }else {
                    this.plateNumberList.shift();
                    this.plateNumberList.unshift(e.toUpperCase());
                }
                var temparr = [];
                this.plateNumberList.forEach((item,index) =>{
                    if(item.indexOf(e.toUpperCase()) != -1){
                        temparr.push(item);
                    }
                })
                this.plateNumberList = temparr;
            }else{
                this.plateNumberList = [];
                this.plateNumberList =JSON.parse(JSON.stringify(this.plateNumberListCopy))
            }
        },
        carriageNumberInput(e){
            let input = document.getElementById("carriageNumberInput");
            input.value = e.toUpperCase();
            if(e){
                if (this.carriageNumberList.length == this.carriageNumberListCopy.length) {
                    this.carriageNumberList.unshift(e.toUpperCase());
                }else{
                    this.carriageNumberList.shift();
                    this.carriageNumberList.unshift(e.toUpperCase());
                }
                var temparr = [];
                this.carriageNumberList.forEach((item,index) =>{
                    if(item.indexOf(e.toUpperCase()) != -1){
                        temparr.push(item);
                    }
                })
                this.carriageNumberList = temparr;
            }else{
                this.carriageNumberList = [];
                this.carriageNumberList =JSON.parse(JSON.stringify(this.carriageNumberListCopy))
            }
        },
        //将汉字与英文、数字、下划线之间添加一个空格
        insert_spacing(str) {
            var p1=/([1])([\u4e00-\u9fa5]+)/gi;
            var p2=/([\u4e00-\u9fa5]+)([1])/gi;
            return str.replace(p1, "$1 $2").replace(p2, "$1 $2")
        },
        btnClick: function () {
            if(this.inputVal==''){
                this.$message.warning("识别内容不能为空！");
                return;
            }
            if(this.inputVal.indexOf("#") != -1){
            var inputList = this.inputVal.replace(/^(\s|#)+|(\s|#)+$/g, '').split("#");
            if(inputList.length<=1){
                this.getSingleData();
            }else{
                for(var i = 0; i < inputList.length; i++){
                var index;
                if(inputList[i].indexOf("：") != -1){
                    index = inputList[i].indexOf("：");
                }else if(inputList[i].indexOf("、") != -1){
                    index = inputList[i].indexOf("、");
                }
                var result = inputList[i].substr(index + 1,inputList[i].length);
        
                while(result.indexOf('-') != -1){
                    result=result.replace('-', ' ');
                }
                while(result.indexOf('司机:') != -1){
                    result=result.replace('司机:', ' ');
                }
                while(result.indexOf('司机') != -1){
                    result=result.replace('司机', ' ');
                }
                while(result.indexOf('押运员:') != -1){
                    result=result.replace('押运员:', ' ');
                }
                while(result.indexOf('电话') != -1){
                    result=result.replace('电话', ' ');
                }
                while(result.indexOf('手机号:') != -1){
                    result=result.replace('手机号:', ' ');
                }
                while(result.indexOf('手机号') != -1){
                    result=result.replace('手机号', ' ');
                }
                while(result.indexOf('身份证号码') != -1){
                    result=result.replace('身份证号码', ' ');
                }
                while(result.indexOf('身份证') != -1){
                    result=result.replace('身份证', ' ');
                }
                // 将汉字和数字中间添加空格
                inputList[i]=this.insert_spacing(result);
                var resultList=inputList[i].trim().split(/\s+/);
                inputList[i]=resultList;
                }
            }
            // 转换展示的新数组
            var newLists = [];
            inputList.forEach((el, index) => {
                var obj = {
                name: "订单"+(index + 1),
                orderData: el,
                };
                newLists.push(obj);
            });
            this.newInputList=newLists;
            
            //展示订单列表
            this.is_smart_list=true;
            this.orderList=this.newInputList
            
            }else{
                this.getSingleData();
            }
        },
        getSingleData:function(){
            var index;
            if(this.inputVal.indexOf("：") != -1){
             index = this.inputVal.indexOf("：");
            }else if(this.inputVal.indexOf("、") != -1){
             index = this.inputVal.indexOf("、");
            }
            var result = this.inputVal.substr(index + 1,this.inputVal.length);

            while(result.indexOf('-') != -1){
             result=result.replace('-', ' ');
            }
            while(result.indexOf('司机:') != -1){
             result=result.replace('司机:', ' ');
            }
            while(result.indexOf('司机') != -1){
             result=result.replace('司机', ' ');
            }
            while(result.indexOf('押运员:') != -1){
             result=result.replace('押运员:', ' ');
            }
            while(result.indexOf('电话') != -1){
             result=result.replace('电话', ' ');
            }
            while(result.indexOf('手机号:') != -1){
             result=result.replace('手机号:', ' ');
            }
            while(result.indexOf('手机号') != -1){
             result=result.replace('手机号', ' ');
            }
            while(result.indexOf('身份证号码') != -1){
             result=result.replace('身份证号码', ' ');
            }
            while(result.indexOf('身份证') != -1){
             result=result.replace('身份证', ' ');
            }
            // 将汉字和数字中间添加空格
            var lists=this.insert_spacing(result).trim().split(/\s+/);
            this.orderListDetail=lists;
            //关闭智能识别窗口
            this.is_smart=false;
            this.getInfoDetails();
        },
        getInfoDetails(){
            var countName=0;
            var countPhone=0;
            var countIdCard=0;
            for(let item of this.orderListDetail){   
                let tempItem = item.toUpperCase()
            //车牌号验证
            if (/(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9]{1}$)/.test(tempItem)) {
                this.form.plateNumber=tempItem;
                this.getCurrDiscount();
            }
            if (/(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[挂]{1}$)/.test(tempItem)) {
                this.form.carriageNumber=tempItem;
            }
            //姓名验证
            if (/^[\u4E00-\u9FA5A-Za-z]+$/.test(item)) {
                if(item.length<=6){
                    countName+=1;
                    if(countName==1){
                        this.form.driverName=item;
                    }else{
                        this.form.escortName=item;
                    }
                }
            }
            //手机号码验证：
            if (/^((13[0-9])|(14[0-9])|(15[0-9])|(17[0-9])|(18[0-9]))\d{8}$/.test(item)) {
                countPhone+=1;
                if(countPhone==1){
                 this.form.driverMobile=item;
                }else{
                  this.form.escortMobile=item;
                }
            }
            //身份证验证：
            if (/(\d{15}$)|(\d{18}$)|(^\d{17}(\d|X|x)$)/.test(item)) {
                countIdCard+=1;
                // if(countIdCard==1){
                //     this.driverIdCardNum=item;
                // }else{
                //     this.supercargoIdCardNum=item;
                // }
                }
            }
        },
        btnClickList(e){
            //关闭智能识别窗口
            this.is_smart_list=false;
            this.is_smart=false;
            this.orderListDetail=e;
            this.getInfoDetails();
        },
        // selectComMethod(name){
        //     if(name.length > 1){
        //         this.is_select = true;
        //         request.get("company/option?keyword="+name).then(res=> {
        //             if(res.data && res.data.length > 0){
        //                 this.componys = res.data;
        //             }else{
        //                 this.componys = [];
        //             }
        //             this.is_select = false;
        //         }).catch(err=>{
        //             this.is_select = false;
        //         });
        //     }
        // },
        getCompany(){
            request.get("company/option").then(res=>{
                this.componys = res.data;
            }).catch(err=>{
            });
        },
        handleClose(address){
            this.form.destinations.splice(this.form.destinations.indexOf(address),1);
        },
        addAddress(){
            this.$prompt('请输入卸液地址信息', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPlaceholder:"请输入卸液地址信息",
                inputPattern: /^.+$/,
                inputErrorMessage: '请输入卸液地址信息'
            }).then(({ value }) => {
                if(this.form.destinations.indexOf(value) > -1){
                    this.$message.warning("已有此卸液地址,请勿重复添加");
                    return false;
                }
                if(this.form.destinations.length > 5){
                    this.$message.warning("卸液地址不能超过5个");
                    return false;
                }
                this.form.destinations.push(value);
                this.$message.success("添加卸液地信息成功");
            });
        },
        prov(th){
            this.activeNum = parseInt(th) -1;
        },
        next(th){
            if(th == 0){
                this.$refs["basicForm"].validate(valid=>{
                    if(!valid) return false;
                    this.activeNum = parseInt(th) + 1;
                });
            }else if(th == 1){
                this.$refs["priceForm"].validate(valid=>{
                    if(!valid) return false;
                    this.activeNum = parseInt(th) + 1;
                });
            }
        },
        getGoodsList(){
            request.get("goods/com_dropdown?com_id="+this.form.comId).then(res=>{
                this.goods_list = this.goods_list.concat(res.data);
                this.addForm.goodsId=res.data[0].id

                this.is_ok = true;
                this.goods_list = res.data;
                var data= this.goods_list.filter(function(item){
                    return item.name== "LNG"; 
                })
                if(data[0].name== "LNG"){
                    this.isShowLng=true;
                }else{
                    this.isShowLng=false;
                }
                this.form.goodsId=data[0].id;
                this.goodsChange(data[0].id)
            }).catch(err=>{
                this.is_ok = true;
            });
        },
        //产品变动
        goodsChange(id){
            request.get("goods/"+id).then(res=>{
                 if(res.data.name== "LNG"){
                    this.isShowLng=true;
                }else{
                    this.isShowLng=false;
                }
                this.form.realPrice = res.data.price;
                if(res.data.isTemCut && res.data.temCutPrice){
                    this.form.temCut = res.data.temCutPrice;
                }else{
                    this.form.temCut = 0;
                }
                if(res.data.allowQuota){
                    this.form.saleCut = res.data.allowQuota;
                }else{
                    this.form.saleCut = 0;
                }
                this.activeGoods = res.data;
            }).catch(err=>{
                console.log(err);
            });
        },
        comChange(id){
            request.get("company/detail?id="+id).then(res=>{
                this.activeCom = res.data;
                this.getCarInfo(res.data.id);
                this.getGoodsList();
            }).catch(err=>{
                console.log(err);
            });
        },
        getCarInfo(id){
            this.plateNumberList=[];
            this.plateNumberListCopy=[];
            this.driverNameList=[];
            this.carriageNumberList=[];
            this.carriageNumberListCopy=[];
            this.driverMobileList=[];
            request.get("order/recom/"+id).then(res=>{
                this.vehicleLists = res.data;
                for (let i = 0; i < res.data.length; i++) {
                    this.plateNumberList.push(res.data[i].plateNumber);
                    this.plateNumberListCopy.push(res.data[i].plateNumber);
                    this.driverNameList.push(res.data[i].driverName);
                    this.carriageNumberList.push(res.data[i].carriageNumber);
                    this.carriageNumberListCopy.push(res.data[i].carriageNumber);
                    this.driverMobileList.push(res.data[i].driverMobile);
                }
                this.unique(this.plateNumberList);
                this.unique(this.plateNumberListCopy);
                this.unique(this.driverNameList);
                this.unique(this.carriageNumberList);
                this.unique(this.carriageNumberListCopy);
                this.unique(this.driverMobileList);
            }).catch(err=>{
                console.log(err);
            });
        },
        // 数组去重
        unique(arr) {
            for (let i = 0; i < arr.length; i++) {
                for(let j = i+1; j < arr.length; j++){
                    if(arr[i]==arr[j]){
                        arr.splice(j,1);
                        j--;
                    }
                }
            }
            return arr;
        },
        WOStatusChange(e){
           this.form.plateNumber=e;
           this.getCurrDiscount();
        },
        //本厂/其他改变
        typeChange(type){
            if(type == 0){
                this.supplierId = "";
            }
        },
        querySearchExpressName(str,callback){
            request.post("company/logistics_supplier_option",{type:2,keyword:str}).then(res=>{
                if(res.data && res.data.length){
                    let arr = [];
                    for(let item of res.data){
                        arr.push({value:item.displayName});
                    }
                    callback(arr);
                }
            }).catch(err=>{
                console.log(err);
            });
        },
        getCurrDiscount(){
            request.post("car/get_curr_discount",{plateNumber:this.form.plateNumber}).then(res=>{
               if(res.data==null){
                    this.currDiscountData=0;
               }else if(res.data.price){
                    this.currDiscountData=res.data.price;
               }
            }).catch(err=>{
                console.log(err);
            });
        },
        //提交其他费用
        addOther(){
            this.$refs["addForm"].validate(valid=>{
                if(!valid) return false;
                this.addOtherDialog = false;
                this.form.otherFee.push(deepClone(this.addForm));
                this.addForm = {
                    name:"",
                    num:""
                };
                this.$refs["addForm"].resetFields();
                this.$message.success("添加成功");
            });
        },
        delOther(data){
            this.form.otherFee.splice(data.$index,1);
        },
        submitOrder(){
            this.$refs["basicForm"].validate(valid=>{
                    if(!valid) return false;
                    let total = this.parseTotal();
                    if(typeof total == "undefined" || isNaN(total) || !total){
                        this.$message.warning("数字有误,请检查!");
                        return false;
                    }

                    this.form.total = total;
                    let nextBalance = this.parseNextBalance();
                    if(isNaN(nextBalance)){
                        this.$message.warning("数字有误,请检查!");
                        return false;
                    }
                    if(nextBalance < -20000){
                        this.$confirm(`该企业当前余额不足,仍差 ${-parseFloat(nextBalance)} 元货款,确定发货吗? (欠款发货需要财务和总经理审批方可执行)`, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.submit(true);
                        });
                    }else{
                        this.submit(false);
                    }
            });      

        },
        //提交
        submit(is_q = false){
            this.is_post = true;
            //注释掉了  --不明白这句代码的逻辑是啥--不能在这样玩骚操做
            // if(this.$route.query.id!=undefined){
            //     this.form.comId=this.editData.baseInfo.comId
            // }
            request.post("order/create",this.form).then(res=>{
                if(res.code==200){
                    this.$message.success("计划单创建成功!");
                    this.$router.push({name:'plan_query'});
                }
                // this.$confirm('添加计划操作成功,是否继续添加?', '提示', {
                //                 confirmButtonText: '继续添加',
                //                 cancelButtonText: '跳转至计划单列表页',
                //                 type: 'warning'
                //             }).then(() => {
                //                 this.addAgain();
                //             }).catch(() => {
                //                 this.toList();
                //             });
                // if(is_q){
                //     this.$message.success("计划单创建成功!");
                //     this.$router.push({name:'plan_index'});
                // }else{
                //     this.$message.success("计划单创建成功!");
                //     this.$router.push({name:'plan_index'}); 
                // }
                this.activeNum = 3;
                this.is_post = false;
            }).catch(err=>{
            //    this.form.comId=this.editData.baseInfo.comName
                this.is_post = false;
            });
        },
        parseEndPrice(){
            let res = "";
            try{
                //装货量
                let weight = parseFloat(this.form.planWeight);
                let real_price = parseFloat(this.form.realPrice);
                let com_price = parseFloat(this.form.temCut);
                let sale_price = parseFloat(this.form.saleCut);
                let other = 0;
                // for(let item of this.form.otherFee){
                //     other += parseFloat(item.num);
                // }
                res = math.round(math.evaluate(`${real_price} - ${com_price} - ${sale_price} - ${this.currDiscountData} + ${other}`),2);
                if(isNaN(res)){
                    return "";
                }else{
                    return res;
                }
            }catch(e){
                console.log("错误",e);
            }finally{
                return res;
            }
        },
        parseTotal(){
            let price = this.parseEndPrice();
            if(isNaN(price) || !price){
                return "";
            }else{
                let other = 0;
                for(let item of this.form.otherFee){
                    other += parseFloat(item.num);
                }
                let weight = parseFloat(this.form.planWeight);
                return math.round(math.evaluate(`${weight} * (${price} + ${other})`),2).toFixed(2);
            }
        },
        parseNextBalance(){
            if(isNaN(this.parseTotal()) || !this.parseTotal()){
                return this.activeCom.balance.toFixed(2);
            }else{
                let total = this.parseTotal();
                return math.evaluate(`${this.activeCom.balance} - ${total}`).toFixed(2);
            }
        },
        parseSupplierId(supplierId){
            for(let item of this.supplier_list){
                if(item.id == supplierId){
                    return item.name;
                }
            }
            return "";
        },
        //再加一条
        addAgain(){
            this.$refs["basicForm"].resetFields();
            this.$refs["priceForm"].resetFields();
            this.form = {
                comId:"",//公司id
                // comName:'',
                type:0,// 0 本厂计划  1其他计划
                supplierId:"",//供应商id
                transport:0, // 0 自提  1配送
                date:"", //时间
                plateNumber:"",
                carriageNumber:"",
                driverName:"",
                driverMobile:"",
                escortName:"",
                escortMobile:"",
                destinations:[],
                expressName:"",//物流公司
                goodsId:"",
                planWeight:"22.5",
                realPrice:"",
                temCut:"",
                saleCut:"",
                remark:"",
                otherFee:[],
                total:0
            };
            this.activeNum = 0;
        },
        toList(){
            this.addAgain();
            this.$router.replace({name:'plan_index'});
        },
        get_supplier_list(){
            request.post("company/logistics_supplier_option",{type:1,keyword:""}).then(res=>{
                this.supplier_list = res.data;
            }).catch(err=>{
                console.log(err);
            });
        },
        getData(){
            let id = this.$route.query.id;
            if(id==undefined){
                this.form = {
                comId:"",//公司id
                type:0,// 0 本厂计划  1其他计划
                supplierId:"",//供应商id
                transport:0, // 0 自提  1配送
                date:"", //时间
                plateNumber:"",
                carriageNumber:"",
                driverName:"",
                driverMobile:"",
                escortName:"",
                escortMobile:"",
                destinations:[],
                expressName:"",//物流公司
                goodsId:"",
                planWeight:"22.5",
                realPrice:"",
                temCut:"",
                saleCut:"",
                remark:"",
                otherFee:[],
                total:0
            };
            this.activeNum = 0;
            this.is_ok = true;
            }else{
                
                request.get("order/detail?id="+id).then(res=>{
                    if(res.code==200){
                        this.editData=res.data
                        this.form = {
                            comId:res.data.baseInfo.comId,//公司id
                            // comName:res.data.baseInfo.comName,
                            type:0,// 0 本厂计划  1其他计划
                            supplierId:"",//供应商id
                            transport:0, // 0 自提  1配送
                            date:this.dates[0], //时间
                            plateNumber:res.data.baseInfo.plateNumber,
                            carriageNumber:res.data.baseInfo.carriageNumber,
                            driverName:res.data.baseInfo.driverName,
                            driverMobile:res.data.baseInfo.driverMobile,
                            escortName:res.data.baseInfo.escortName,
                            escortMobile:res.data.baseInfo.escortMobile,
                            destinations:[],
                            expressName:res.data.baseInfo.expressName,//物流公司
                            goodsId:res.data.baseInfo.goodsId,
                            planWeight:"22.5",
                            realPrice:res.data.moneyInfo.realPrice,
                            temCut:res.data.moneyInfo.temCut,
                            saleCut:res.data.moneyInfo.saleCut,
                            // remark:res.data.remark,
                            remark:"",
                            otherFee:[],
                            total:0,
                        };
                        this.getGoodsList();
                        this.comChange(res.data.baseInfo.comId);
                        this.getCurrDiscount();
                    }else{
                        this.$message.error('复制计划失败')
                    }
                    })
                }
        }
    },
    created(){
        let time = new Date();
        this.dates.push(parseTime(time,"{y}-{m}-{d}"));
        time = time.getTime()+86400000;
        this.dates.push(parseTime(time,"{y}-{m}-{d}"));
        
    },
    mounted() {
        this.getData();
        // this.getGoodsList();
        this.get_supplier_list();
        this.getCompany();
    },
    watch:{
        '$route'(){
            this.getData();
            //  this.getGoodsList();
        }
    }
}
</script>

<style scoped lang="scss">
    .view_section_right_view {
        padding: 9px;
        background: #1890ff;
        border-radius: 8px;
        margin-right: 15%;
        align-items: center;
        font-weight: 400;
        color: #ffffff;
    }
    .flex{
        display: flex;
        justify-content: space-between;
    }
    .box{
        padding: 5%;
    }
    .textarea-box{
        width: 90%;
    }
    .remark-box{
        color: #9a9898
    }
    .btn-box{
        display: flex;
        justify-content: space-around;
        font-size: 18px;
    }
    .btn-common{
        width: 35%;
        padding: 10px;
        border-radius: 10px;
        text-align: center;
        margin-top: 15%;
    }
    .btn-reset{
        background:#DCDCDC;
    }
    .btn-identify{
        background:#658bef;
        color: #ffffff;
    }
    .box-title{
        font-size: 18px;
        margin-bottom: 3%;
    }
    .order-list{
        padding: 2%;
        margin: 2%;
        border-bottom: 2px solid #DCDCDC;
    }
    .order-text{
        padding: 12px 0;
        font-size: 16px;
        color: #696969;
    }
    .flexBox{
        display: flex;
        justify-content: center;
    }
</style>
